import { Link, useLocation } from "react-router-dom";
import { useAuth } from "../App";

const PublicHeader = () => {
  const location = useLocation();
  const isLanding = location.pathname === "/";
  const isBoutique = location.pathname === "/boutique";
  const { user } = useAuth();

  const navLink = (anchor, label) => {
    if (isLanding) {
      return <a href={`#${anchor}`} className="hover:text-[#09090B] transition-colors">{label}</a>;
    }
    return <Link to={`/#${anchor}`} className="hover:text-[#09090B] transition-colors">{label}</Link>;
  };

  const portalHref = user?.role === "client"
    ? (user?.account_type === "web" ? "/portal/boutique" : "/portal")
    : "/dashboard";

  return (
    <header className="sticky top-0 z-50 bg-white/80 backdrop-blur-xl border-b border-zinc-200" data-testid="public-header">
      {/* Main nav bar */}
      <div className="max-w-7xl mx-auto px-4 md:px-12 flex items-center justify-between h-14 gap-2">
        <Link to="/" className="flex items-center gap-2 shrink-0">
          <img src="/logo.png" alt="Micro Multimédia" className="h-8 w-auto" />
          <span className="font-black tracking-tighter text-base sm:text-lg text-[#09090B] hidden sm:block" style={{ fontFamily: "'Outfit', sans-serif" }}>
            MICRO MULTIMÉDIA
          </span>
        </Link>
        <nav className="hidden lg:flex items-center gap-6 text-sm font-medium text-zinc-600 shrink-0">
          {navLink("sav", "SAV")}
          {navLink("services", "Services")}
          {navLink("tarifs", "Tarifs")}
          <Link to="/boutique" className={`hover:text-[#09090B] transition-colors ${isBoutique ? "text-[#09090B] font-semibold" : ""}`}>Boutique</Link>
          {navLink("livres", "Livres scolaires")}
          {navLink("contact", "Contact")}
        </nav>
        <div className="flex items-center gap-3 shrink-0">
          {user ? (
            <Link
              to={portalHref}
              className="bg-[#0055FF] text-white text-xs sm:text-sm font-semibold px-3 sm:px-4 py-2 sm:py-2.5 hover:bg-[#0044CC] transition-colors whitespace-nowrap"
              data-testid="nav-portal-btn"
            >
              Mon espace
            </Link>
          ) : (
            <>
              <Link to="/login" className="text-sm font-medium text-zinc-600 hover:text-[#09090B] transition-colors hidden sm:block" data-testid="nav-login-link">
                Se connecter
              </Link>
              <Link
                to="/login"
                className="bg-[#0055FF] text-white text-xs sm:text-sm font-semibold px-3 sm:px-4 py-2 sm:py-2.5 hover:bg-[#0044CC] transition-colors whitespace-nowrap"
                data-testid="nav-signup-btn"
              >
                Créer un compte
              </Link>
            </>
          )}
        </div>
      </div>
      {/* Partner badges bar */}
      <div className="bg-[#09090B] flex items-center justify-center gap-3 sm:gap-5 py-1.5 px-4">
        <span className="font-black text-[10px] sm:text-xs text-white leading-none" style={{ fontFamily: "'Outfit', sans-serif" }}>CANAL+</span>
        <span className="w-px h-3 bg-white/30" />
        <span className="font-black text-[10px] sm:text-xs text-[#00a8e8] leading-none" style={{ fontFamily: "'Outfit', sans-serif" }}>CANALBOX</span>
        <span className="w-px h-3 bg-white/30" />
        <span className="font-bold text-[10px] sm:text-xs text-white/80 leading-none whitespace-nowrap" style={{ fontFamily: "'Outfit', sans-serif" }}>TV Caraïbes</span>
        <span className="hidden sm:inline text-[9px] text-white/50 ml-1">Distributeur officiel</span>
      </div>
    </header>
  );
};

export default PublicHeader;
